import { z } from "zod";

const VenueOrderAdminSchema = z.object({
  id: z.string().uuid(),
  source: z.enum(["Ingested", "Routed", "Manual"]),
  venue_name: z.string(),
  venue_account_id: z.string().uuid().nullable(),
  venue_order_ref: z.string().nullable(),
  gateway_inbox_id: z.string().nullable(),
  external_order_id: z.string().nullable(),
  instrument_name: z.string(),
  venue_symbol: z.string(),
  symbol_unmapped: z.boolean(),
  side: z.enum(["Buy", "Sell"]),
  status: z.enum([
    "Open",
    "Partial",
    "Filled",
    "PendingCancellation",
    "Canceled",
    "Rejected",
    "Expired",
    "Liquidated",
  ]),
  status_source: z.enum(["overlay", "fills_only"]).nullable(),
  venue_status: z.string().nullable(),
  size: z.string(),
  filled_amount: z.string(),
  average_fill_price: z.string().nullable(),
  fee: z.string().nullable(),
  fee_currency: z.string().nullable(),
  first_fill_at: z.string().nullable(),
  last_fill_at: z.string().nullable(),
  created_date: z.string().nullable(),
  fill_count: z.number().int(),
});

export { VenueOrderAdminSchema };
